import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input, OnChanges } from '@angular/core';
import { CatalogFeature, FileService, StoreService } from "compob2b-libs";
import { take, tap } from 'rxjs';

@Component({
  selector: 'app-last-category',
  standalone: false,
  templateUrl: './last-category.component.html',
  styleUrl: './last-category.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LastCategoryComponent implements OnChanges {
  @Input() catalog!: CatalogFeature;
  /**
   * Межстрочный интервал описания категории из глобальных настроек (CMZ-415).
   * null = не настроено: биндинг не выставляет CSS-переменную, и
   * `.last-category__features` берёт запасное значение из вёрстки.
   */
  readonly contentLineHeight = inject(StoreService).getSettings()?.contentLineHeight ?? null;
  noPhotoSrc = '/assets/images/product/nofoto.jpg';
  showDiagramsModal = false;
  showCertificatesModal = false;
  loading = false;

  constructor(
    private fileService: FileService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnChanges(): void {

    console.log('catalog', this.catalog)
    if (!this.catalog?.id) {
      this.cdr.detectChanges()
    }
  }

  get descriptionLines(): string[] {
    return this.catalog?.description
      ?.replace(/<br\s*\/?>/gi, '\n')
      ?.replace(/<[^>]+>/g, '')
      ?.split('\n')
      .map(line => line.trim())
      .filter(line => line) || [];
  }

  get hasDiagrams(): boolean {
    return !!this.catalog?.diagrams?.length;
  }

  get hasCertificates(): boolean {
    return !!this.catalog?.certificates?.length;
  }

  getImageUri(picture: string): string {
    return picture && picture !== '.'
      ? this.fileService.getImageSrc(picture)
      : this.noPhotoSrc;
  }

  openDiagramsModal(): void {
    this.showDiagramsModal = true;
    console.log('openDiagramsModal')
    this.cdr.detectChanges();
  }

  closeDiagramsModal(): void {
    this.showDiagramsModal = false;
    this.cdr.detectChanges();
  }

  openCertificatesModal(): void {
    this.showCertificatesModal = true;
    this.cdr.detectChanges();
  }

  closeCertificatesModal(): void {
    this.showCertificatesModal = false;
    this.cdr.detectChanges();
  }

  download(doc: { fileName: string; header: string }): void {
    this.loading = true;
    this.fileService.downloadUrl('/document/download/' + doc.fileName).pipe(
      take(1),
      tap((response: Blob) => {
        if (response.size) {
          const pathArray = doc.fileName.split('/');
          const lastIndex = pathArray.length - 1;
          FileService.saveAs(response, pathArray[lastIndex]);
        }
        this.loading = false;
        this.cdr.detectChanges();
      }),
    ).subscribe();
  }

  copyLink(doc: { fileName: string }): void {
    const url = this.fileService.getImageSrc(doc.fileName);
    navigator.clipboard.writeText(url);
  }
}
